/* @flow */
import React, { Component } from 'react';
import { css, names } from 'linaria';

import { Image } from './core';
import Colors from '../constants/Colors';

class PhoneFrame extends Component<{
  size: 'small' | 'large',
  src: string,
  src2x?: string,
  style?: any,
  className: ?string,
  color: string,
}> {
  static defaultProps = {
    size: 'large',
    color: Colors.White,
    style: {},
  };

  getStyles() {
    const { size, className } = this.props;

    if (size === 'small') {
      return [Styles.Device, Styles.SmallDevice, className];
    } else if (size === 'large') {
      return [Styles.Device, Styles.LargeDevice, className];
    }
    return [className];
  }

  render() {
    const { src, src2x, color, style } = this.props;

    return (
      <div className={names(...this.getStyles())} style={{ ...style, backgroundColor: color }}>
        <Image className={Styles.Screenshot} src={src} src2x={src2x} alt="Lugg app" />
      </div>
    );
  }
}

const Styles = {
  Device: css`
    border: 1px solid rgba(0, 0, 0, 0.02);
    box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.03);
  `,
  SmallDevice: css`
    width: 160px;
    padding: 24px 4px;
    border-radius: 16px;
  `,
  LargeDevice: css`
    width: 296px;
    padding: 56px 12px;
    border-radius: 30px;
  `,
  Screenshot: css`
    width: 100%;
    vertical-align: 'middle';
  `,
};

export default PhoneFrame;



// WEBPACK FOOTER //
// ./src/ui/components/PhoneFrame.js